import { useStore } from "zustand";

import { FeatureFlagsStore } from "../../../store/featureFlags";
import { discoveryFilterStore } from "../../../store/filters";
import { IHubContentProvider } from "../../../types/providers";
import {
    getInvalidScopeMessage,
    isAccountAgnosticId,
    isScopedToAccount,
    isValidAccount,
} from "../../../utils/permission.utils";
import { ContentUnavailable } from "../../ContentUnavailable";

import { InsightFamiliesViewer } from "./insightFamilies/InsightFamiliesViewer";
import { InsightPackagesViewer } from "./insightPackages/InsightPackagesViewer";
import { MarketingNarrativesViewer } from "./marketingNarratives/MarketingNarrativesViewer";
import { OnDemandInsightsViewer } from "./onDemandInsights/OnDemandInsightsViewer";
import { UnifiedContentsViewer } from "./unifiedContent/UnifiedContentViewer";

const ProviderViewer: React.FunctionComponent<{
    provider: IHubContentProvider;
}> = ({ provider }) => {
    const [useUnifiedSearch] = useStore(FeatureFlagsStore, (state) => [
        state.unifiedSearch,
    ]);

    if (useUnifiedSearch) {
        return <UnifiedContentsViewer />;
    }

    switch (provider) {
        case IHubContentProvider.UNIFIED:
            return <UnifiedContentsViewer />;
        case IHubContentProvider.INSIGHT_FAMILIES:
            return <InsightFamiliesViewer />;
        case IHubContentProvider.PACKAGES:
            return <InsightPackagesViewer />;
        case IHubContentProvider.TEMPLATES:
            return <OnDemandInsightsViewer />;
        case IHubContentProvider.MARKETING_NARRATIVES:
            return <MarketingNarrativesViewer />;
        default:
            return <OnDemandInsightsViewer />;
    }
};

const ContentViewer: React.FunctionComponent<{
    provider: IHubContentProvider;
    isValid: boolean;
    isScoped: boolean;
    marketingContentId?: string;
}> = ({ isValid, isScoped, provider }) => {
    if (isAccountAgnosticId() || (isScoped && isValid)) {
        return <ProviderViewer provider={provider} />;
    }

    return <ContentUnavailable message={getInvalidScopeMessage()} />;
};

export const AllInsightsViewer: React.FunctionComponent = () => {
    const [contentSubType] = useStore(discoveryFilterStore, (state) => [
        state.getContentSubType(),
    ]);

    return (
        <div>
            <ContentViewer
                provider={contentSubType.provider}
                isValid={isValidAccount()}
                isScoped={isScopedToAccount()}
            />
        </div>
    );
};
